module.exports = __webpack_public_path__ + "media/packs/site/assets/images/combook_binding/cover_generator_manual/step2-9d55e40b5b6a2cbf8f5c373ea253e007.png";